import { Badge, Tooltip } from '@radix-ui/themes';
import { usePage } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';

export default function EnvironmentLayout({ children }) {
  const {
    props: { app_version, current_user, env, features },
  } = usePage();
  const { i18n, t } = useTranslation();
  const name = children || env;

  const environmentColors = {
    demo: 'amber',
    development: 'blue',
    preview: 'purple',
    production: 'red',
    staging: 'orange',
    test: 'grass',
  };

  const color = environmentColors[name] || 'gray';
  const hidden =
    features.hide_environment ||
    (!current_user?.admin && name === 'production');

  const badge = (
    <Badge color={color} size="2" variant="solid">
      {i18n.exists(`admin.environments.${name}`)
        ? t(`admin.environments.${name}`)
        : name}
    </Badge>
  );

  return (
    !hidden &&
    (app_version ? (
      <Tooltip content={<code>{app_version}</code>}>{badge}</Tooltip>
    ) : (
      badge
    ))
  );
}
